import Create from './create/CreateFtpConnection';
import Edit from './edit/EditFtpConnection';
import Individual from './individual/FtpConnection';

export default { Edit, Create, Individual };
